import { createApp } from "vue";
import NoticeItem from "../components/NoticeItem.vue";

// 容器元素（所有公告的父容器）
let container: HTMLDivElement;

function ensureContainer() {
  if (!container) {
    container = document.createElement("div");
    container.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      z-index: 99999;
      pointer-events: none;
    `;
    document.body.appendChild(container);
  }
}

/**
 * 显示全服公告（API 调用入口）
 * @param {string} text - 公告内容，如 "玩家XXX获得了传说卡片YYY"
 */
export function showNotice(text: any) {
  ensureContainer();

  // 创建一个包裹元素（每条公告独立）
  const wrapper = document.createElement("div");
  wrapper.style.marginBottom = "10px";
  container.appendChild(wrapper);

  // 创建 Vue 应用并挂载
  const app = createVNodeApp(text);

  app.mount(wrapper);

  // 动画结束后自动清理
  const onAnimationEnd = () => {
    app.unmount();
    wrapper.remove();
    // 如果容器空了，可以考虑移除容器（可选）
  };

  // 监听动画结束（兼容性处理）
  const noticeEl = wrapper.firstElementChild;
  if (noticeEl) {
    noticeEl.addEventListener("animationend", onAnimationEnd, { once: true });
  }
}

// 辅助：创建 VNode 应用（避免重复 import）
function createVNodeApp(text: any) {
  const app = createApp(NoticeItem, { text });
  return app;
}
